import { FormEventHandler, useState } from "react";
import { toast } from "react-toastify";
import { authenticatedFetch } from "../../../hooks/api/api";
import { useL10n } from "../../../hooks/l10n";
import { Button } from "../../Button";
import { VisuallyHidden } from "../../VisuallyHidden";

export type Props = {
  onType: (_partial: string) => void;
  onPick: (_subdomain: string) => void;
};

/**
 * Form with which the user can check whether a given subdomain is still available for them to claim.
 */
export const SubdomainSearchForm = (props: Props) => {
  const l10n = useL10n();
  const [subdomainInput, setSubdomainInput] = useState("");

  const onSubmit: FormEventHandler = async (event) => {
    event.preventDefault();

    // Encoding URI component to handle trailing white spaces
    const isAvailable = await getAvailability(
      encodeURIComponent(subdomainInput),
    );
    if (!isAvailable) {
      toast(
        l10n.getString("error-subdomain-not-available-2", {
          unavailable_subdomain: subdomainInput,
        }),
        { type: "error" },
      );
      return;
    }

    props.onPick(subdomainInput.toLowerCase());
  };

  const onInput: FormEventHandler<HTMLInputElement> = async (event) => {
    setSubdomainInput(event.currentTarget.value);
    props.onType(event.currentTarget.value.toLowerCase());
  };

  return (
    <form onSubmit={onSubmit}>
      <VisuallyHidden>
        <label htmlFor="subdomain">
          {l10n.getString("banner-set-email-domain-input-placeholder-label")}
        </label>
      </VisuallyHidden>
      <input
        type="search"
        value={subdomainInput}
        onInput={onInput}
        placeholder={l10n.getString(
          "banner-set-email-domain-input-placeholder",
        )}
        name="subdomain"
        id="subdomain"
        minLength={1}
        maxLength={63}
        autoCapitalize="none"
      />
      <Button type="submit">
        {l10n.getString("banner-set-email-domain-input-search")}
      </Button>
    </form>
  );
};

async function getAvailability(subdomain: string) {
  const checkResponse = await authenticatedFetch(
    `/accounts/profile/subdomain?subdomain=${subdomain}`,
  );
  if (!checkResponse.ok) {
    return false;
  }
  const checkData: { available: true } = await checkResponse.json();
  return checkData.available;
}
